<script setup>
import { onMounted, computed, ref, defineAsyncComponent, provide } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useGlobalStore } from "@/stores/global";

// 动态导入组件
const MobileNavBar = defineAsyncComponent(() =>
  import("@/components/mobile/MobileNavbar.vue")
);
const MobileToolbar = defineAsyncComponent(() =>
  import("@/components/mobile/MobileToolbar.vue")
);
const DevelopNavBar = defineAsyncComponent(() =>
  import("@/components/develop/DevelopNavbar.vue")
);
const DevelopFooter = defineAsyncComponent(() =>
  import("@/components/develop/DevelopFooter.vue")
);

// 获取当前路由
const route = useRoute();
const showMobileNavbar = computed(() => route.meta.showMobileNavbar !== false);
const showMobileToolbar = computed(
  () => route.meta.showMobileToolbar !== false
);
const showDevelopNavbar = computed(
  () => route.meta.showDevelopNavbar !== false
);
const showDevelopFooter = computed(
  () => route.meta.showDevelopFooter !== false
);

const globalStore = useGlobalStore();
// 根据屏幕宽度判断并导航
const redirectBasedOnWidth = () => {
  globalStore.updateIsDevelop();
};

// 页面滚动
const isScroll = ref(false);
const handleScroll = (e) => {
  const scrollTop = e.target.scrollTop;
  isScroll.value = scrollTop > 14;
};

const scrollContainerRef = ref(null);
const scrollToTop = () => {
  const el = scrollContainerRef.value;
  if (!el) return;

  el.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

provide("scrollToTop", scrollToTop);

onMounted(() => {
  redirectBasedOnWidth();
  window.addEventListener("resize", redirectBasedOnWidth);

  const appEl = document.querySelector(".app-scroll-container");
  appEl.addEventListener("scroll", handleScroll, { passive: true });
});
</script>

<template>
  <div class="app-container">
    <DevelopNavBar
      :isDevelopScroll="isScroll"
      v-if="showDevelopNavbar && globalStore.isDevelop"
    />
    <MobileToolbar v-if="showMobileToolbar && !globalStore.isDevelop" />

    <div ref="scrollContainerRef" class="app-scroll-container">
      <router-view v-slot="{ Component, route }">
        <keep-alive>
          <component
            :is="Component"
            v-if="route.meta.keepAlive"
            :key="route.fullPath"
          />
        </keep-alive>
        <component
          :is="Component"
          v-if="!route.meta.keepAlive"
          :key="route.fullPath"
        />
      </router-view>
      <DevelopFooter v-if="showDevelopFooter && globalStore.isDevelop" />
    </div>

    <MobileNavBar v-if="showMobileNavbar && !globalStore.isDevelop" />
  </div>
</template>

<style scoped>
.app-container {
  height: 100vh;
  height: 100dvh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.app-scroll-container {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior-y: contain;
}
</style>
